var map = {
	"./flag1.png": 6556,
	"./flag10.png": 9622,
	"./flag2.png": 1639,
	"./flag3.png": 1646,
	"./flag4.png": 4737,
	"./flag5.png": 2024,
	"./flag6.png": 6515,
	"./flag7.png": 5754,
	"./flag8.png": 2349,
	"./flag9.png": 1220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4198;